import resolver, {ResolverSettings} from './utils/resolver';
import {BookingSummary, ReservationOrExternalId, ShortReservation} from '../utils/types';

class ReservationApi {
  ENDPOINTS = {
    all: (params = '') => `reservations/?${params}`,
    getOne: (id = '') => `reservations/${id}/`,
    getByExternalId: (id = '') => `reservations/get-with-external-id/?external_id=${id}`,
    getSummary: (id = '') => `guestapp/reservations/${id}/summary/`,
  };

  getOne(id: string, resolverSettings?: ResolverSettings) {
    return resolver<ShortReservation>(
      this.ENDPOINTS.getOne(id),
      {method: 'GET'},
      {version: 'v4', ...resolverSettings},
    );
  }

  getByReservationOrExternalId({id, externalId}: ReservationOrExternalId) {
    const getReservationMethod = externalId
      ? () => this.ENDPOINTS.getByExternalId(externalId)
      : () => this.ENDPOINTS.getOne(id);
    return resolver<ShortReservation>(
      getReservationMethod(),
      {method: 'GET'},
      {version: 'v4'},
    );
  }
  summary(id: string, resolverSettings?: ResolverSettings) {
    return resolver<BookingSummary>(
      this.ENDPOINTS.getSummary(id),
      {method: 'GET'},
      {version: 'v4', ...resolverSettings},
    );
  }
}

export {ReservationApi};
